import {AfterViewInit, Component, ElementRef, Input, Optional, ViewChild} from '@angular/core';
import {DropdownSelectComponent} from '../dropdown-select/dropdown-select.component';
import {NgClass, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-dropdown-select-option',
  imports: [
    NgIf,
    FormsModule,
    NgIf,
    NgClass
  ],
  templateUrl: './dropdown-select-option.component.html',
  styleUrl: './dropdown-select-option.component.scss'
})
export class DropdownSelectOptionComponent implements AfterViewInit {
  @Input() value: any | null = null;
  @ViewChild('template') template: ElementRef | null = null;

  private static id: number = 0;
  private readonly id: number | null = null;

  active = false;
  label = '';

  constructor(
    @Optional() private dropdownSelect: DropdownSelectComponent
  ) {
    this.id = ++DropdownSelectOptionComponent.id;
  }

  isMultiple(): boolean {
    return this.dropdownSelect.multiple;
  }

  getId(): string {
    return 'dropdown-select-option-' + this.id;
  }

  onChange(e: any): void {
    this.dropdownSelect.onOptionChange(this.value, e?.target?.checked);
  }

  onClick(e: any): void {
    if (!this.isMultiple()) {
      this.dropdownSelect.onOptionChange(this.value, true);
    } else {
      e.stopPropagation();
    }
  }

  getElement(): ElementRef | null {
    return this.template;
  }

  isChecked(): boolean {
    return this.dropdownSelect.isChecked(this.value);
  }

  onHover(): void {
    const options = this.dropdownSelect?.options?.toArray?.();
    const index = options?.indexOf(this) ?? -1;
    this.dropdownSelect?.setHoveredIndex(index);
  }

  updateActiveState(): void {
    const options = this.dropdownSelect?.options?.toArray?.();
    const index = options?.indexOf(this) ?? -1;

    this.active = this.dropdownSelect?.activeIndex === index || this.dropdownSelect?.hoveredIndex === index;
  }

  isFiltered(): boolean {
    if (this.dropdownSelect?.searchTerm) {
      return !this.label.includes(<string>this.dropdownSelect?.searchTerm);
    }

    return false;
  }

  ngAfterViewInit(): void {
    const el = this.getElement()?.nativeElement;
    this.label = el?.textContent?.trim().toLowerCase() ?? '';
  }
}
